import { FieldError, Resolver, ResolverError } from 'rhf-v7';
import isEmpty from 'lodash/isEmpty';
import { defineMessage } from 'obt-common';
import { RetryPaymentCheckoutFormValues } from './types';

export const customResolver: Resolver<RetryPaymentCheckoutFormValues> = async (values) => {
  const errors = {} as ResolverError<RetryPaymentCheckoutFormValues>['errors'];

  const isPaymentSourceIdSelected = !!values.selectedPaymentSourceIds && values.selectedPaymentSourceIds.length > 0;

  if (!isPaymentSourceIdSelected) {
    errors.selectedPaymentSourceIds = {
      type: 'required',
      message: defineMessage('No Payment method selected'),
    } as FieldError;
  }

  // TODO: Refactor this validation, feels primitive
  if (isEmpty(errors)) {
    return {
      values,
      errors: {},
    };
  }

  return {
    values: {},
    errors,
  };
};
